<template>
  <div class="OtherSettings">
    <!-- <el-form class="OtherSettingsForm" :model="data1" v-if="false">
      <el-form-item>
        输出分辨率：（等于或大于实际屏幕分辨率，最小不小于256)
      </el-form-item>
      <el-form-item>
        高:<el-input v-model="data1.height"></el-input>
        宽:<el-input v-model="data1.width"></el-input>
        <div class="OtherSettingsRight">
          <el-popover placement="top" width="200" trigger="click" v-model="visible1">
            <p>重启后立即生效，是否立即重启？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible1 = false">取消</el-button>
              <el-button type="primary" size="mini" @click="setData1">确定</el-button>
            </div>
            <el-button slot="reference">应用</el-button>
          </el-popover>

          <el-button type="primary" style="float: right" @click="getData1">刷 新</el-button>
        </div>
      </el-form-item>
      <el-divider></el-divider>
    </el-form>
    <el-form class="OtherSettingsForm" :model="data2" v-if="false">
      <el-form-item>
        <el-switch v-model="switch1"></el-switch>软件打折 （用于超宽超高屏）
      </el-form-item>
      <el-form-item>
        屏幕类型：
        <el-select v-model="data2.data.type">
          <el-option v-for="item in Type" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        每折大小：<el-input v-model="data2.data.type" style="width: 25.5%;margin-left: 0"></el-input>
        <div class="OtherSettingsRight">
          <el-popover placement="top" width="160" v-model="visible2">
            <p>重启后立即生效，是否立即重启？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible2 = false">取消</el-button>
              <el-button type="primary" size="mini" @click="setData2">确定</el-button>
            </div>
            <el-button slot="reference">应用</el-button>
          </el-popover>
          <el-button type="primary" style="float: right" @click="getData2">刷 新</el-button>
        </div>
      </el-form-item>
      <el-divider></el-divider>
    </el-form>
    <el-form class="OtherSettingsForm" v-if="false">
      <el-form-item>
        <el-switch v-model="isOpenCloudRebootStatu">
        </el-switch>监控连接状态，当断开<el-select v-model="cloudRebootValue" placeholder="请选择" style="width: 120px">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>分钟时自动重连

        <div class="OtherSettingsRight">
          <el-popconfirm title="确定应用！" @onConfirm="confirmCloudReboot">
            <el-button slot="reference">应用</el-button>
          </el-popconfirm>
          <el-button type="primary" style="float: right" @click="getCloudRebootStatus">刷 新</el-button>
        </div>
      </el-form-item>
      <el-form-item>
        <el-switch v-model="isOpenSleeper">
        </el-switch>定时重启， <el-time-picker style="width: 120px;" v-model="sleeperValue" placeholder="任意时间点" :clearable="false">
        </el-time-picker>自动重启任务
        <div class="OtherSettingsRight">
          <el-popconfirm title="每天当前时刻执行自动重启任务!" @onConfirm="confirmSleeper">
            <el-button slot="reference">应用</el-button>
          </el-popconfirm>
          <el-button type="primary" style="float: right" @click="getAutoReboot">刷 新</el-button>
        </div>
      </el-form-item>
    </el-form> -->

    <ul>
      <li class="os-li">
        <div class="os-li-wt">{{$t('ctcio1')}}</div>
        <div class="os-li-set">
          <div class="os-li-c">
            {{$t('ctcio2')}} : <el-input :placeholder="$t('ctcio3')" size="small" v-model="data1.width" style="width: 120px;margin-right: 32px;" />
            {{$t('ctcio3')}} : <el-input :placeholder="$t('ctcio5')" size="small" v-model="data1.height" style="width: 120px" />
          </div>
          <div class="os-li-but">
            <el-button size="small" @click="getData1">{{$t('ctcio6')}}</el-button>
            <el-popconfirm :title="$t('ctcio7')" @onConfirm="setData1">
              <el-button slot="reference" size="small" type="primary">{{$t('ctcio9')}}</el-button>
            </el-popconfirm>
          </div>
        </div>
      </li>
      <li class="os-li">
        <div class="os-li-wt"><el-switch v-model="switch1"></el-switch> {{$t('ctcio10')}}</div>
        <div class="os-li-set">
          <div class="os-li-c">
            {{$t('ctcio11')}} : <el-select v-model="data2.data.type" size="small" style="width: 120px;margin-right: 32px;">
              <el-option v-for="item in Type" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            每折大小 : <el-input :placeholder="$t('ctcio12')" size="small" v-model="data1.height" style="width: 120px" />
          </div>
          <div class="os-li-but">
            <el-button size="small" @click="getData2">{{$t('ctcio6')}}</el-button>
            <el-popconfirm title="确定应用！" @onConfirm="setData2">
              <el-button slot="reference" size="small" type="primary">{{$t('ctcio9')}}</el-button>
            </el-popconfirm>
          </div>
        </div>
      </li>
      <li class="os-li">
        <div class="os-li-wt"> <el-switch v-model="isOpenCloudRebootStatu"></el-switch> 监控连接状态</div>
        <div class="os-li-set">
          <div class="os-li-c">
            当断开 <el-select v-model="cloudRebootValue" placeholder="请选择" style="width: 120px" size="small">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" size="small">
              </el-option>
            </el-select> 分钟时自动重连
          </div>
          <div class="os-li-but">
            <el-button size="small" @click="getCloudRebootStatus">{{$t('ctcio6')}}</el-button>
            <el-popconfirm :title="$t('ctcio8')" @onConfirm="confirmCloudReboot">
              <el-button slot="reference" size="small" type="primary">{{$t('ctcio9')}}</el-button>
            </el-popconfirm>
          </div>
        </div>
      </li>
      <li class="os-li">
        <div class="os-li-wt"> <el-switch v-model="isOpenSleeper" size="small"> </el-switch> {{$t('ctcio15')}}</div>
        <div class="os-li-set">
          <div class="os-li-c">
            设置 <el-time-picker style="width: 120px;" v-model="sleeperValue" placeholder="任意时间点" :clearable="false" size="small">
            </el-time-picker> 自动重启任务
          </div>
          <div class="os-li-but">
            <el-button size="small" @click="getAutoReboot">{{$t('ctcio6')}}</el-button>
            <el-popconfirm :title="$t('ctcio8')" @onConfirm="confirmSleeper">
              <el-button slot="reference" size="small" type="primary">{{$t('ctcio9')}}</el-button>
            </el-popconfirm>
          </div>
        </div>
      </li>
      <li class="os-li">
        <div class="os-li-wt"> <el-switch v-model="isOpenSensorAll" size="small"> </el-switch> {{$t('ctcio17')}}</div>
        <div class="os-li-set">
          <div class="os-li-c">
            <el-switch v-model="isAutoBright" size="small"> </el-switch> {{$t('ctcio18')}}
          </div>
          <div class="os-li-but">
            <el-button size="small" @click="()=>{
               getAutoBright();getAutoSensor();
            }">{{$t('ctcio6')}}</el-button>
            <el-popconfirm :title="$t('ctcio8')" @onConfirm="confirmSensorAll">
              <el-button slot="reference" size="small" type="primary">{{$t('ctcio9')}}</el-button>
            </el-popconfirm>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { timeFormatting, reTimeFormatting, } from "@/assets/scripts/dateFormatting";
export default {
  name: "OtherSettings",
  props: {
    currentDetail: {
      type: Object
    }
  },
  data() {
    return {
      isOpenCloudRebootStatu: false,
      cloudRebootValue: '5',
      isOpenSensorAll: false,
      isAutoBright: false,
      isOpenSleeper: false,
      sleeperValue: reTimeFormatting("08:30:00"),
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      options: [{
        value: '5',
        label: '5'
      }, {
        value: '10',
        label: '10'
      }, {
        value: '15',
        label: '15'
      }, {
        value: '20',
        label: '20'
      }, {
        value: '25',
        label: '25'
      }],
      value: '',
      data1: {},
      data2: {
        data: {
          type: 0,
          value: null,
        }
      },
      data3: {},
      data4: {},

      switch1: false,
      Type: [
        { label: this.$t('ctcio19'), value: 0 },
        { label: this.$t('ctcio20'), value: 1 },
        { label: this.$t('ctcio21'), value: 2 },
      ],
    }
  },
  methods: {
    init() {
      this.myWebSocket.onmessage = (val) => {
        let upresult = JSON.parse(val.data);
        if (upresult.type === "invoke_method") {
          const uri = upresult.data.uri;
          const data = JSON.parse(upresult.data.response);
          switch (uri) {
            case "getResolution": {
              this.data1 = data;
            } break;
            case "getDiscount": {
              this.data2 = data;
              this.switch1 = data.value == 0 ? false : true;
            } break;
            case "getCloudRebootStatus": {
              this.data3 = data;
              this.isOpenCloudRebootStatu = data.status == 0 ? false : true;
            } break;
            case "getCloudMonitorTime": {
              this.data4 = data;
            } break;
            case "getAutoReboot": {
              const { rebootTime, status } = data;
              this.isOpenSleeper = status == 0 ? false : true;
              this.sleeperValue = reTimeFormatting(rebootTime);
            } break;
            case "getAutoSensor": {
              const { status } = data
              this.isOpenSensorAll = status == 0 ? false : true;
              console.log('getAutoSensor', data);
            } break;
            case "getAutoBright": {
              const { status } = data
              this.isAutoBright = status == 0 ? false : true;
              console.log('getAutoBright', data);
            } break;
            default:
              break;
          }
          // this.$msg({ message: data.code == 200 ? "发送成功！" : "发送失败！", type: "success", showClose: true });
        }
      }
    },
    confirmCloudReboot() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "set_cloud_reboot_status", methodParams: { status: this.isOpenCloudRebootStatu ? 1 : 0 } } }]);
      this.sendCmd([{ type: "invoke_method", data: { methodName: "set_cloud_monitor_time", methodParams: { time: this.cloudRebootValue } } }]);
    },
    confirmSleeper() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "set_auto_reboot", methodParams: { status: this.isOpenSleeper ? 1 : 0, rebootTime: timeFormatting(this.sleeperValue) } } }]);
      // getAutoReboot
    },

    confirmSensorAll() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "setAutoSensor", methodParams: { status: this.isOpenSensorAll ? 1 : 0 } } }]);
      this.sendCmd([{ type: "invoke_method", data: { methodName: "setAutoBright", methodParams: { status: this.isAutoBright ? 1 : 0 } } }]);
    },

    getData1() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getResolution", methodParams: {} } }], "get");
    },
    getAutoReboot() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getAutoReboot", methodParams: {} } }], "get");
    },

    getAutoSensor() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getAutoSensor", methodParams: {} } }], "get");
    },
    getAutoBright() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getAutoBright", methodParams: {} } }], "get");
    },

    getData2() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getDiscount", methodParams: {} } }], "get");
    },
    getCloudRebootStatus() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getCloudRebootStatus", methodParams: {} } }], "get");
    },
    getData4() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getCloudMonitorTime", methodParams: {} } }], "get");
    },
    setData1() {
      this.visible1 = true

      this.sendCmd([{ type: "invoke_method", data: { methodName: "changeResolution", methodParams: { postData: JSON.stringify(this.data1) } } }]);
    },
    setData2() {
      this.visible2 = true;

      this.sendCmd([{ type: "invoke_method", data: { methodName: "setDiscount", methodParams: { postData: JSON.stringify(this.data2) } } }]);
    },
    sendCmd(commands_info, type = "set") {

      this.init();

      const { id, sn, type_id, name } = this.currentDetail;
      let devices_info = [{ id, sn, type_id, name, cache: {} }];

      this.$http.post("/admin/Command/generalCommand", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type
      }, () => {
        // console.log(res);
        type === 'set' && this.$msg({ message: this.$t('ctcio22'), type: "success" });
      });
    },
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  mounted() {
    this.init();
    this.getData1();
    this.getData2();
    this.getCloudRebootStatus();
    this.getData4();
    this.getAutoReboot();
    this.getAutoBright();
    this.getAutoSensor();


  },
}
</script>

<style  lang="scss" scoped>
.OtherSettings {
  width: 100%;
  height: 100%;
  ul {
    padding: 32px;
    .os-li {
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      border-bottom: 1px solid #d7ecf3;
      .os-li-set {
        display: flex;
        padding-left: 32px;
      }
      .os-li-c {
        width: calc(100% - 140px);
      }
      .os-li-but {
        width: 140px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  // .OtherSettingsForm {
  //   width: 45%;
  //   margin-left: 5%;
  //   margin-top: 2.5%;
  // }
  // .el-input {
  //   width: 15%;
  //   margin-left: 2%;
  //   margin-right: 2%;
  // }
  // .OtherSettingsRight {
  //   float: right;
  //   width: 160px;
  // }
}
</style>
